import React from 'react'
import ActiveServiceTxnTableContainer from './ActiveServiceTxnTableContainer'
import * as Badge from './ActiveServiceTxnPanelBadge'

export default class ActiveServiceTxnPanel extends React.Component {
  render() {
    return (
      <div className="w-full">
        {/* Stats and Legend Section */}
        <div className="w-full mb-4">
          <div className="border-t border-gray-200 pt-4"></div>

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            {/* Badges */}
            <div className="flex flex-col md:flex-row gap-3 w-full md:w-auto">
              <Badge.ActiveCustomerAmountBadge />
              <Badge.AlmostTimeoutAmountBadge />
              <Badge.TimeoutAmountBadge />
            </div>

            {/* Legend/Actions Info - Hidden on mobile, shown on desktop */}
            <div className="hidden lg:flex items-center text-sm text-gray-600 bg-white rounded-lg border border-gray-200 px-4 py-2 shadow-sm">
              <div className="flex items-center mr-4">
                <svg
                  className="w-4 h-4 mr-1.5 text-green-600"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                <strong className="font-medium">Check-out</strong>
              </div>
              <span className="text-gray-400 mr-4">|</span>
              <div className="flex items-center mr-4">
                <svg
                  className="w-4 h-4 mr-1.5 text-gray-600"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
                <strong className="font-medium">Add Customer Feedback</strong>
              </div>
              <span className="text-gray-400 mr-4">|</span>
              <div className="flex items-center">
                <svg
                  className="w-4 h-4 mr-1.5 text-gray-600"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                    clipRule="evenodd"
                  />
                </svg>
                <strong className="font-medium">Extend Time Limit</strong>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <ActiveServiceTxnTableContainer {...this.props} />
      </div>
    )
  }
}
